import { BaseRequest, IBaseRequest } from '../../BaseRequest';
import { Invoice, toInvoiceXml } from '../../dataObjects/Invoice';

export interface ICreateInvoiceRequest extends IBaseRequest {
    INVOICE: Invoice;
}

export class CreateInvoiceRequest extends BaseRequest implements ICreateInvoiceRequest {
    public INVOICE: Invoice;

    constructor(server: string, session: string, invoice: Invoice) {
        super(server, session);
        this.INVOICE = invoice;
    }

    public toXml(): string {
        var parameters: string = super.toXml();
        parameters += toInvoiceXml(this.INVOICE);
        return super.wrapperXml('CreateInvoice', parameters);
    }
}
